import api from './api';

export const fetchPublicConfig = () => api.get('/config/public').then(r => r.data);
export const fetchShipments = () => api.get('/shipments').then(r => r.data);
export const fetchShipment = (id) => api.get(`/shipments/${id}`).then(r => r.data);
export const createShipment = (payload) => api.post('/shipments', payload).then(r => r.data);
export const suggestHsCode = (payload) => api.post('/shipments/hs-code/suggest', payload).then(r => r.data);
export const confirmProductHsCode = (shipmentId, productId, payload) =>
  api.post(`/shipments/${shipmentId}/products/${productId}/hs-code/confirm`, payload).then(r => r.data);
export const fetchChecklistByShipment = (id) => api.get(`/checklists/by-shipment/${id}`).then(r => r.data);
export const markItemUploaded = (checklistId, itemId) =>
  api.post(`/checklists/${checklistId}/items/${itemId}/mark-uploaded`).then(r => r.data);
export const runValidation = (shipmentId) =>
  api.post(`/validation-runs/run/${shipmentId}`).then(r => r.data);
export const fetchValidationRun = (shipmentId) =>
  api.get(`/validation-runs/by-shipment/${shipmentId}`).then(r => r.data);
export const fetchReports = () => api.get('/reports').then(r => r.data);
export const previewReport = (shipmentId) => api.get(`/reports/preview/${shipmentId}`).then(r => r.data);
export const fetchAiGuidance = (shipmentId, question) =>
  api.post('/ai/guidance', { shipment_id: shipmentId, question }).then(r => r.data);
